import { OpenAPI as OpenAPIGeocoder } from '@/modules/api-geocoder';
import { OpenAPI as OpenAPIRouting } from '@/modules/api-routing';

OpenAPIGeocoder.BASE = import.meta.env.VITE_GEOCODING_URL || '';
OpenAPIRouting.BASE = import.meta.env.VITE_ROUTING_URL || '';
